import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as parse from 'date-fns/parse';
import * as format from 'date-fns/format';

// Services
import {
  IGetQuestionsRecipientsResponse,
  getQuestionRecipients
} from '../../services/question';

// Types
type IRecipient = IGetQuestionsRecipientsResponse;

// Components
import Box from '../../components/Box';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '../../components/Table';
import { CircularProgress } from '../../components/Progress';

// Component
interface IProps {
  networkId: string;
  questionId: string;
}

class QuestionDialogRecipients extends React.Component<IProps> {
  @observable recipients: IRecipient[] | null = null;

  componentDidMount() {
    this.getRecipients();
  }

  async getRecipients() {
    const { networkId, questionId } = this.props;

    this.recipients = await getQuestionRecipients({
      params: { networkId },
      query: { questionId }
    });
  }

  render() {
    if (this.recipients === null) {
      return (
        <Box py={5} align="center">
          <CircularProgress />
        </Box>
      );
    }
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Answer</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.recipients.map(item => (
            <TableRow key={item.userId}>
              <TableCell>{`${item.firstName} ${item.lastName}`}</TableCell>
              <TableCell>
                {item.answered
                  ? format(parse(item.answered), 'Do MMMM YYYY')
                  : ''}
              </TableCell>
              <TableCell>{item.value || ''}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
}

// Exports
export default inject('store')(observer(QuestionDialogRecipients));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkQuestions/QuestionDialogRecipients.tsx